(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["section-blocks"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
    const toggle = event.target.closest('.section-blocks--read-more-toggle');
    if (!toggle) return;

    const target = document.getElementById(toggle.getAttribute('aria-controls'));
    if (!target) return;

    const expand = target.dataset.expanded !== 'true';
    const label = expand ? toggle.dataset.lessText : toggle.dataset.moreText;

    target.dataset.expanded = expand;
    toggle.setAttribute('aria-expanded', expand);
    toggle.dataset.text = label;
    toggle.querySelector('span').textContent = label;
  });
  } catch(e) { console.error(e); }
})();

})();
